export default __webpack_public_path__ + "static/media/1026.379004d2.png";